import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad } from '../components/';
import { Dictionary } from '../Dati';


interface ICampoPasswordProps extends Dati.IBaseProps {
    Valore: string;
    DimensioneCSS: number;
    Placeholder?: string;
    Required?: boolean;
    AutoComplete?: string;
}

export class CampoPassword extends BasePureComponent<ICampoPasswordProps, {}> {
    private _Placeholder: string = "";
    private _Required: boolean = false;
    private _AutoComplete: string = "";

    constructor(props: any) {
        super(props);

        this._Placeholder = this.props.Placeholder != undefined ? this.props.Placeholder : "";
        this._Required = this.props.Required != undefined ? this.props.Required : false;
        this._AutoComplete = this.props.AutoComplete != undefined ? this.props.AutoComplete : "";
    }

    private _ColoreBarraPassword: string = "";

    private _LarghezzaBarraPassword = {
        width: "0%"
    };

    private valoreRobustezzaPassword(pw: string): number {
        if (pw == undefined)
            return 0;

        let points: number = pw.length; //un punto per ogni carattere
        let numRx: RegExp = /[0-9]/; //espressione regolare per i numeri (oppure [:digit:])
        let almRx: RegExp = /[a-z]/; //espressione regolare per le lettere minuscole
        let ALMRx: RegExp = /[A-Z]/; //espressione regolare per le lettere maiuscole
        let poiRx: RegExp = /[.:;,!\"£$%\&\/\(\)\=\?\^\'\ì\[\]@#]/; // espressione regolare per i simboli
        if (numRx.test(pw)) {
            points = points + 4; // +4 punti se ci sono dei numeri
        }
        if (almRx.test(pw)) {
            points = points + 2; // + 2 punti se ci sono delle lettere minuscole
        }
        if (ALMRx.test(pw)) {
            points = points + 3; // + 2 punti se ci sono delle lettere maiuscole
        }
        if (poiRx.test(pw)) {
            points = points + 6; // + 6 punti se ci sono dei simboli
        }
        return points;
    }

    private BarraRobustezzaPassword() {
        let robustezza: number = this.valoreRobustezzaPassword(this.props.Valore);
        if (robustezza < 5) {
            this._ColoreBarraPassword = "";
            this._LarghezzaBarraPassword = {
                width: robustezza * 4 + "%"
            };
        } else if (robustezza >= 5 && robustezza < 10) {
            this._ColoreBarraPassword = "progress-bar bg-danger";
            this._LarghezzaBarraPassword = {
                width: robustezza * 4 + "%"
            };
        } else if (robustezza >= 10 && robustezza < 15) {
            this._ColoreBarraPassword = "progress-bar kt-portlet__head";
            this._LarghezzaBarraPassword = {
                width: robustezza * 4 + "%"
            };
        } else if (robustezza >= 15 && robustezza < 20) {
            this._ColoreBarraPassword = "progress-bar bg-success";
            this._LarghezzaBarraPassword = {
                width: robustezza * 4 + "%"
            };
        } else {
            this._ColoreBarraPassword = "progress-bar bg-info";
            this._LarghezzaBarraPassword = {
                width: "100%"
            };
        }
    }

    public render() {
        this.BarraRobustezzaPassword();
        return <div className={Glob.DimensioneCSS(this.props.DimensioneCSS)}>
            <div className="kt-input-icon kt-input-icon--left">
                <input type="password" className="form-control" value={this.props.Valore || ""} id={this.props.Id} name={this.props.Name} onChange={this.props.OnChange} required={this._Required} autoComplete={this._AutoComplete} />
                <span className="kt-input-icon__icon kt-input-icon__icon--right"><span><i className="fa fa-lock"></i></span></span>
            </div>
            <div className="progress" style={{ marginTop: 5 }}>
                <div className={this._ColoreBarraPassword} role="progressbar" style={this._LarghezzaBarraPassword}></div>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/CampoPassword.tsx